import { render, staticRenderFns } from "./ClientEditDetails.vue?vue&type=template&id=1aa220a9&scoped=true&"
import script from "./ClientEditDetails.vue?vue&type=script&lang=js&"
export * from "./ClientEditDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientEditDetails.vue?vue&type=style&index=0&id=1aa220a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa220a9",
  null
  
)

export default component.exports